<template>
  <b-table
    striped
    hover
    caption-top
    :fields="fields"
    :items="items"
    responsive="sm"
    head-variant="light"
    class="text-right mb-5"
  >
    <template v-slot:table-caption
      ><h2 class="h5 text-center text-white bg-dark my-0 py-3">
        {{ stockSymbol }}
        {{ companyName }}_{{ headline }}_{{ unitOfTime }}
        <span class="h6">單位：{{ unitOfNumber }}</span>
      </h2>
    </template>
    <template v-slot:head()="scope">
      <span class="text-nowrap">
        {{ scope.column === "subTitle" ? "期別" : scope.column }}
      </span>
      <br />
      <span class="text-nowrap">{{ scope.label }}</span>
    </template>
    <template v-slot:cell(subTitle)="{ item }">
      {{
        item.subTitle === "每股EBIDTA" || item.subTitle === "每股EPS"
          ? `${item.subTitle} (元)`
          : ["現金再投資比例", "現金股利分配比例"].includes(item.subTitle)
          ? `${item.subTitle} (％)`
          : item.subTitle
      }}
    </template>
  </b-table>
</template>

<script>
export default {
  name: "SheetYear",
  props: {
    stockSymbol: {
      type: [String, Number],
      required: true
    },
    companyName: {
      type: String,
      required: true
    },
    headline: {
      type: String,
      required: true
    },
    unitOfTime: {
      type: String,
      required: true
    },
    unitOfNumber: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  methods: {
    tdClass(value) {
      return Math.sign(value) === -1 && "text-danger";
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .b-table-sticky-column {
  text-align: left;
}
::v-deep .table-b-table-default {
  text-align: left;
}
</style>
